import { FC } from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';

type Props = {
  label: string;
  boldLabel?: boolean;
  value: string;
};

export const ReadonlyForm: FC<Props> = ({ label, boldLabel = true, value }) => (
  <>
    {boldLabel ? (
      <Heading as="h5" size="sm" color="modal.labelColor">
        {label}
      </Heading>
    ) : (
      <Text fontSize="md" color="modal.labelColor">
        {label}
      </Text>
    )}
    <Box
      borderBottom="1px"
      color="modal.valueColor"
      borderBottomColor="modal.borderBottomColor"
    >
      <Text mt="10px" mx="10px" fontSize="md">
        {value}
      </Text>
    </Box>
  </>
);
